module.exports = __webpack_public_path__ + "img/fk.fkb2c8d11.svg";